import React from 'react';
import { CheckCircle2, Target, Eye, Award } from 'lucide-react';

export const About = () => {
  const values = [
    {
      icon: Target,
      title: 'Precision Engineering',
      description: 'Every instrument is crafted with meticulous attention to detail and quality.'
    },
    {
      icon: Award,
      title: 'Quality Assurance',
      description: 'ISO certified processes ensure consistent excellence in every product.'
    },
    {
      icon: Eye,
      title: 'Innovation Focus',
      description: 'Continuous R&D to incorporate latest technology in our instruments.'
    }
  ];

  const highlights = [
    'Over 15 years of manufacturing excellence',
    'State-of-the-art production facility',
    'Experienced team of engineers and technicians',
    'Comprehensive quality control at every stage',
    'Custom solutions for unique requirements',
    'Global distribution network'
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left - Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://images.unsplash.com/photo-1614935151651-0bea6508db6b"
                alt="Laboratory Research"
                className="rounded-xl shadow-lg h-64 w-full object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1562789278-dac7af7fb5b1"
                alt="Scientists Working"
                className="rounded-xl shadow-lg h-64 w-full object-cover mt-8"
              />
            </div>
            <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-blue-600 text-white px-6 py-4 rounded-xl shadow-xl">
              <div className="text-center">
                <div className="text-3xl font-bold">15+</div>
                <div className="text-sm">Years of Excellence</div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-6">
            <div>
              <h3 className="text-blue-600 font-semibold text-sm uppercase tracking-wide mb-2">
                About BioSpectrix
              </h3>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Pioneering Scientific Instrument Manufacturing
              </h2>
              <p className="text-gray-600 leading-relaxed">
                BioSpectrix Private Limited is a leading manufacturer of high-precision scientific instruments 
                serving research institutions, pharmaceutical companies, and industrial laboratories across the globe.
              </p>
            </div>

            <p className="text-gray-600 leading-relaxed">
              Our commitment to innovation, quality, and customer satisfaction has made us a trusted partner 
              for laboratories seeking reliable, state-of-the-art equipment. We combine cutting-edge technology 
              with traditional craftsmanship to deliver instruments that meet the highest standards.
            </p>

            {/* Highlights */}
            <div className="space-y-3">
              {highlights.map((highlight, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle2 className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">{highlight}</span>
                </div>
              ))}
            </div>

            {/* Values */}
            <div className="grid sm:grid-cols-3 gap-6 pt-6">
              {values.map((value, index) => {
                const Icon = value.icon;
                return (
                  <div key={index} className="text-center">
                    <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-3">
                      <Icon className="h-6 w-6 text-blue-600" />
                    </div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm">{value.title}</h4>
                    <p className="text-xs text-gray-600">{value.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
